import styled, { css } from 'styled-components';

/**
 * The margin (in form of height) is required in full-screen test case view.
 * It prevents the editor toolbar from creating scroll overflow on the container.
 */
export const BorderStyled = styled.div<{ shouldAddMargin: boolean }>`
  ${({ shouldAddMargin }) => {
    if (shouldAddMargin) {
      return css`
        height: 30px;
      `;
    }
  }};

  width: 100%;
  border-top: 1px solid var(--ds-border, var(--ds-fb-border));
`;

export const ContainerStyled = styled.div<{
  shouldEnableOverflowScroll: boolean;
}>`
  ${({ shouldEnableOverflowScroll }) => {
    if (shouldEnableOverflowScroll) {
      return css`
        max-height: 75vh;
        overflow-y: auto;
      `;
    }
  }};
`;
